import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import vr from "@/store/vr";
import stage from "@/store/stage";
import parts from "@/store/parts";
import magrobo from "@/store/magrobo";

export default new Vuex.Store({
  state: {
    magroboImage: null,
    shareImage: null
  },
  mutations: {
    magroboImage(state, payload) {
      state.magroboImage = payload;
    },
    shareImage(state, payload) {
      state.shareImage = payload;
    }
  },
  actions: {},
  modules: {
    vr,
    stage,
    parts,
    magrobo
  }
});
